// ============================================================
// VCS.UI — Icons, Toast, Tooltips, Dialogs, Theme
// ============================================================
window.VCS = window.VCS || {};

VCS.UI = class {

    // ── Konstanten ───────────────────────────────────────────

    static TOOLTIP_GAP = 6;
    static THEME_KEY   = 'call-theme';

    // SVG-Icons (alle UI-Icons zentral hier)
    ICONS = {
        mic         : `<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="9" y="3" width="6" height="11" rx="3"></rect><path d="M6 10a6 6 0 0 0 12 0"></path><path d="M12 16v5"></path><path d="M8 21h8"></path></svg>`,
        chatMic     : `<svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M12 1a4 4 0 0 0-4 4v6a4 4 0 0 0 8 0V5a4 4 0 0 0-4-4z"/><path d="M19 10a1 1 0 0 0-2 0 5 5 0 0 1-10 0 1 1 0 0 0-2 0 7 7 0 0 0 6 6.93V20a1 1 0 0 0 2 0v-3.07A7 7 0 0 0 19 10z"/></svg>`,
        chatCam     : `<svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M15 4H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-2.5l3.3 2.47A1 1 0 0 0 22.8 16V8a1 1 0 0 0-1.5-.87L18 9.5V7a3 3 0 0 0-3-3z"/></svg>`,
        micOff      : `<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="9" y="3" width="6" height="11" rx="3"></rect><path d="M6 10a6 6 0 0 0 12 0"></path><path d="M12 16v5"></path><path d="M8 21h8"></path><path d="M4 4l16 16"></path></svg>`,
        cam         : `<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="7" width="13" height="10" rx="2"></rect><path d="M16 10l5-3v10l-5-3z"></path></svg>`,
        camOff      : `<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="7" width="13" height="10" rx="2"></rect><path d="M16 10l5-3v10l-5-3z"></path><path d="M4 4l16 16"></path></svg>`,
        speaker     : `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 10h4l5-4v12l-5-4H4z"></path><path d="M17 9a4 4 0 0 1 0 6"></path><path d="M19.5 7a7 7 0 0 1 0 10"></path></svg>`,
        speakerOff  : `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 10h4l5-4v12l-5-4H4z"></path><path d="M17 9l4 6"></path><path d="M21 9l-4 6"></path></svg>`,
        bell        : `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9a6 6 0 1 1 12 0v4l2 2v1H4v-1l2-2z"></path><path d="M10 18a2 2 0 0 0 4 0"></path></svg>`,
        bellOff     : `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9a6 6 0 1 1 12 0v4l2 2v1H4v-1l2-2z"></path><path d="M10 18a2 2 0 0 0 4 0"></path><path d="M4 4l16 16"></path></svg>`,
        notifyOn    : `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16v11H7l-3 3z"></path><path d="M9 9h6"></path><path d="M9 12h4"></path></svg>`,
        notifyOff   : `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16v11H7l-3 3z"></path><path d="M9 9h6"></path><path d="M9 12h4"></path><path d="M4 4l16 16"></path></svg>`,
        share       : `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l4 4"></path><path d="M12 3l-4 4"></path><path d="M12 3v12"></path><path d="M5 13v4a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4v-4"></path></svg>`,
        copy        : `<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="9" y="9" width="10" height="10" rx="2"></rect><rect x="5" y="5" width="10" height="10" rx="2"></rect></svg>`,
        plus        : `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"></path><path d="M5 12h14"></path></svg>`,
        blurOn      : `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="5"></circle><path d="M12 3v2"></path><path d="M12 19v2"></path><path d="M3 12h2"></path><path d="M19 12h2"></path></svg>`,
        blurOff     : `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="5"></circle><path d="M12 3v2"></path><path d="M12 19v2"></path><path d="M3 12h2"></path><path d="M19 12h2"></path><path d="M4 4l16 16"></path></svg>`,
        hangup      : `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 11c2-3.5 5.5-5 9-5s7 1.5 9 5"></path><path d="M3 11v3.5l3.5.5L8 11"></path><path d="M21 11v3.5l-3.5.5L16 11"></path></svg>`,
        user        : `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4"></circle><path d="M4 20c0-4 4-7 8-7s8 3 8 7"></path></svg>`,
        phone       : `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.81.36 1.6.68 2.34a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.74-1.25a2 2 0 0 1 2.11-.45c.74.32 1.53.55 2.34.68a2 2 0 0 1 1.72 2.03z"></path></svg>`,
        hourglass   : `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 2h12v5l-4 4 4 4v5H6v-5l4-4-4-4z"></path></svg>`,
        ban         : `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M5.7 5.7l12.6 12.6"></path></svg>`,
        mutedSpeaker: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 10h4l5-4v12l-5-4H4z"></path><path d="M17 14l4-4"></path><path d="M21 14l-4-4"></path></svg>`,
    };

    // ── Konstruktor ──────────────────────────────────────────

    constructor() {
        // Tooltip-State (privat, kein shared state)
        this._tooltipEl      = null;
        this._tooltipTimeout = null;

        // View-Cache
        this._view = {
            toastContainer: $('#toastContainer'),
            confirmOverlay: $('#confirmOverlay'),
            confirmMessage: $('#confirmMessage'),
            confirmIcon:    $('#confirmIcon'),
            confirmYes:     $('#confirmYes'),
            confirmNo:      $('#confirmNo'),
            confirmLater:   $('#confirmLater'),
        };
    }

    // ── Icon-Helfer ──────────────────────────────────────────

    // Setzt das innerHTML eines Buttons auf ein SVG-Icon
    setButtonIcon(id, iconName) {
        const icon = this.ICONS[iconName];
        if (!icon) {
            return;
        }
        $(`#${id}`).html(icon);
    }

    // Setzt das innerHTML eines Elements auf ein SVG-Icon + optionale CSS-Klasse auf dem SVG
    setElementIcon(id, iconName, cls) {
        const icon = this.ICONS[iconName];
        if (!icon) {
            return;
        }
        const $el = $(`#${id}`).html(icon);
        if (cls) {
            $el.find('svg').addClass(cls);
        }
    }

    // Setzt alle statischen SVG-Icons beim Start
    initStaticIcons() {
        this.setButtonIcon('btnHangup', 'hangup');
        this._updatePreJoinToggleButtons();

        this.setElementIcon('previewCamOff-icon',    'user');
        this.setElementIcon('hostWaiting-icon',      'phone');
        this.setElementIcon('guestWaiting-icon',     'hourglass');
        this.setElementIcon('approvalOverlay-icon',  'bell');
        this.setElementIcon('remoteCamOff-avatar',   'user');
        this.setElementIcon('remoteMuteIcon',        'micOff');
        this.setElementIcon('localCamOff-icon',      'user');
        this.setElementIcon('deniedOverlay-icon',    'ban');
    }

    // ── Toast ────────────────────────────────────────────────

    showToast(message, type = 'info', ms = 3000) {
        const icons = {
            info   : `<svg class="toast-icon" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/></svg>`,
            success: `<svg class="toast-icon" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>`,
            error  : `<svg class="toast-icon" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/></svg>`,
            warning: `<svg class="toast-icon" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/></svg>`,
        };
        const iconHtml = icons[type] || '';
        const $toast   = $('<div>')
            .addClass(`toast-item toast-${type} toast-in`)
            .html(iconHtml + `<span>${message}</span>`);

        this._view.toastContainer.append($toast);

        setTimeout(() => {
            $toast.addClass('toast-out');
            setTimeout(() => $toast.remove(), 300);
        }, ms);
    }

    // ── Confirm-Dialog ───────────────────────────────────────

    // noText (2026-09-08): Der Standard 'Abbrechen' passt nicht ueberall. Bei
    // einer Ja/Nein-Frage vor dem Anruf liest sich 'Abbrechen' so, als wuerde
    // man den ganzen Anruf abbrechen. Ohne den Parameter bleibt alles wie bisher.
    showConfirm(message, iconHtml, yesText, noText) {
        return new Promise((resolve) => {
            const { confirmOverlay: $overlay, confirmMessage: $msg,
                    confirmIcon: $icon, confirmYes: $yes, confirmNo: $no } = this._view;

            if (!$overlay.length) {
                resolve(confirm(message));
                return;
            }

            $msg.text(message);
            $icon.html(iconHtml || '').toggle(!!iconHtml);
            $yes.text(yesText || t('confirmYes'));
            $no.text(noText || t('confirmNo'));
            $overlay.removeClass('hidden');

            const cleanup = (result) => {
                $overlay.addClass('hidden');
                $yes.off('click', onYes);
                $no.off('click', onNo);
                $overlay.off('click', onBg);
                resolve(result);
            };
            const onYes = () => cleanup(true);
            const onNo  = () => cleanup(false);
            const onBg  = (e) => { if (e.target === $overlay[0]) { cleanup(false); } };

            $yes.on('click', onYes);
            $no.on('click', onNo);
            $overlay.on('click', onBg);
        });
    }

    // Wie showConfirm, aber mit dritter Wahl als Textknopf darunter.
    // Liefert 'yes' | 'no' | 'later'. Ein Tipp neben die Karte zaehlt als
    // 'later' -- wer wegtippt, hat sich noch nicht entschieden.
    // Erster Einsatz: Gruppeneinladung (Beitreten / Ablehnen / Spaeter).
    showChoice(message, iconHtml, yesText, noText, laterText) {
        return new Promise((resolve) => {
            const { confirmOverlay: $overlay, confirmMessage: $msg, confirmIcon: $icon,
                    confirmYes: $yes, confirmNo: $no, confirmLater: $later } = this._view;

            if (!$overlay.length) {
                resolve(confirm(message) ? 'yes' : 'later');
                return;
            }

            $msg.text(message);
            $icon.html(iconHtml || '').toggle(!!iconHtml);
            $yes.text(yesText || t('confirmYes'));
            $no.text(noText || t('confirmNo'));
            $later.text(laterText || '').removeClass('hidden');
            $overlay.removeClass('hidden');

            const cleanup = (result) => {
                $overlay.addClass('hidden');
                $later.addClass('hidden');
                $yes.off('click', onYes);
                $no.off('click', onNo);
                $later.off('click', onLater);
                $overlay.off('click', onBg);
                resolve(result);
            };
            const onYes   = () => cleanup('yes');
            const onNo    = () => cleanup('no');
            const onLater = () => cleanup('later');
            const onBg    = (e) => { if (e.target === $overlay[0]) { cleanup('later'); } };

            $yes.on('click', onYes);
            $no.on('click', onNo);
            $later.on('click', onLater);
            $overlay.on('click', onBg);
        });
    }

    // ── Tooltips ─────────────────────────────────────────────

    applyTooltips() {
        // No-op: Tooltips lesen i18n-Keys live via t() in _showTooltip
    }

    // ── Theme ────────────────────────────────────────────────

    getStoredThemeMode() {
        return localStorage.getItem(VCS.UI.THEME_KEY) || 'auto';
    }

    setThemeMode(mode) {
        if (mode !== 'auto' && mode !== 'light' && mode !== 'dark') {
            mode = 'auto';
        }
        localStorage.setItem(VCS.UI.THEME_KEY, mode);
        const effective = this._getEffectiveTheme(mode);
        document.documentElement.classList.add('theme-transitioning');
        this._applyTheme(effective);
        this.syncEmojiPickerTheme();
        setTimeout(() => {
            document.documentElement.classList.remove('theme-transitioning');
        }, 350);
        this.updateThemeToggleUI();
    }

    updateThemeToggleUI() {
        const mode = this.getStoredThemeMode();
        $('.theme-toggle-btn').each(function() {
            $(this).toggleClass('theme-toggle-btn--active', $(this).data('theme') === mode);
        });
    }

    syncEmojiPickerTheme() {
        const theme  = document.documentElement.getAttribute('data-theme');
        const picker = $('#emojiPickerWrap').find('emoji-picker')[0];
        if (!picker) {
            return;
        }
        picker.classList.remove('light', 'dark');
        picker.classList.add(theme === 'dark' ? 'dark' : 'light');
    }

    // ── Blur-Button UI ───────────────────────────────────────

    updateBlurButtonUI() {
        const $btn = $('#btnBlur');
        if (!$btn.length) {
            return;
        }
        const on = VCS.state.blurEnabled;
        this.setButtonIcon('btnBlur', on ? 'blurOn' : 'blurOff');
        $btn.toggleClass('btn-active-red', on)
            .attr('title', t(on ? 'blurOn' : 'blurOff'));
    }

    // ── Init ─────────────────────────────────────────────────

    init() {
        this._initTheme();
        this._setupTooltips();
        this.initStaticIcons();
        this._initAppHeight();
    }

    // ── Private Methoden ─────────────────────────────────────

    // Chrome auf Android rechnet 100dvh nach einem Neuladen (z.B. PWA-Update)
    // manchmal zu hoch -- die untere Navigation rutscht unter den Rand.
    // Deshalb die echte Fensterhoehe als --app-height setzen (body.h-dvh in
    // call.scss). innerHeight statt visualViewport: die Tastatur soll die
    // Seite nicht mitschrumpfen (iOS-Keyboard-Fit im Chat regelt das selbst).
    _initAppHeight() {
        const root = document.documentElement;
        const apply = () => {
            const h = window.innerHeight;
            if (h > 0) {
                root.style.setProperty('--app-height', h + 'px');
            }
        };
        apply();
        window.addEventListener('resize', apply);
        window.addEventListener('orientationchange', apply);
        window.addEventListener('pageshow', apply);
        // Nach dem ersten Layout nochmal: direkt nach dem Neuladen kann der
        // Wert noch alt sein.
        requestAnimationFrame(apply);
        setTimeout(apply, 500);
    }

    _updatePreJoinToggleButtons() {
        this.setButtonIcon('preToggleMic', VCS.state.audioMuted ? 'micOff' : 'mic');
        this.setButtonIcon('preToggleCam', VCS.state.videoOff   ? 'camOff' : 'cam');
        $('#preToggleMic').toggleClass('btn-active-red', VCS.state.audioMuted);
        $('#preToggleCam').toggleClass('btn-active-red', VCS.state.videoOff);
        $('#previewCamOff').toggleClass('hidden', !VCS.state.videoOff);
    }

    _getSystemTheme() {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }

    _getEffectiveTheme(mode) {
        if (mode === 'light' || mode === 'dark') {
            return mode;
        }
        return this._getSystemTheme();
    }

    _applyTheme(theme) {
        document.documentElement.setAttribute('data-theme', theme);
        document.documentElement.setAttribute('data-bs-theme', theme);
        const meta = document.querySelector('meta[name="theme-color"]');
        if (meta) {
            meta.setAttribute('content', theme === 'dark' ? '#0b0f19' : '#f5f5f7');
        }
    }

    _initTheme() {
        const mode = this.getStoredThemeMode();
        this._applyTheme(this._getEffectiveTheme(mode));
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
            if (this.getStoredThemeMode() === 'auto') {
                this._applyTheme(this._getSystemTheme());
                this.syncEmojiPickerTheme();
            }
        });
        this.updateThemeToggleUI();
    }

    _ensureTooltipEl() {
        if (this._tooltipEl) {
            return this._tooltipEl;
        }
        this._tooltipEl = document.createElement('div');
        this._tooltipEl.className = 'app-tooltip';
        document.body.appendChild(this._tooltipEl);
        return this._tooltipEl;
    }

    _positionTooltip(anchor) {
        const tip = this._ensureTooltipEl();
        const r   = anchor.getBoundingClientRect();
        const tw  = tip.offsetWidth;
        const th  = tip.offsetHeight;
        const vw  = window.innerWidth;
        const vh  = window.innerHeight;
        const GAP = VCS.UI.TOOLTIP_GAP;

        let top, left;
        if (r.top - th - GAP >= 4) {
            top = r.top - th - GAP;
            left = r.left + r.width / 2 - tw / 2;
        } else if (r.bottom + th + GAP <= vh - 4) {
            top = r.bottom + GAP;
            left = r.left + r.width / 2 - tw / 2;
        } else if (r.left - tw - GAP >= 4) {
            top  = r.top + r.height / 2 - th / 2;
            left = r.left - tw - GAP;
        } else {
            top  = r.top + r.height / 2 - th / 2;
            left = r.right + GAP;
        }

        tip.style.left = Math.max(4, Math.min(left, vw - tw - 4)) + 'px';
        tip.style.top  = Math.max(4, Math.min(top,  vh - th - 4)) + 'px';
    }

    _showTooltip(anchor) {
        const key = anchor.dataset.tooltipI18n;
        if (!key) {
            return;
        }
        const tip = this._ensureTooltipEl();
        tip.textContent = t(key);
        tip.classList.remove('app-tooltip--visible');
        tip.style.top  = '-9999px';
        tip.style.left = '-9999px';
        requestAnimationFrame(() => {
            this._positionTooltip(anchor);
            tip.classList.add('app-tooltip--visible');
        });
    }

    _hideTooltip() {
        clearTimeout(this._tooltipTimeout);
        this._tooltipTimeout = null;
        this._tooltipEl?.classList.remove('app-tooltip--visible');
    }

    _setupTooltips() {
        if (window.matchMedia('(hover: none)').matches) {
            return;
        }
        document.addEventListener('pointerenter', (e) => {
            const anchor = e.target.closest?.('[data-tooltip-i18n]');
            if (!anchor) {
                return;
            }
            clearTimeout(this._tooltipTimeout);
            this._tooltipTimeout = setTimeout(() => this._showTooltip(anchor), 100);
        }, true);

        document.addEventListener('pointerleave', (e) => {
            if (e.target.closest?.('[data-tooltip-i18n]')) {
                this._hideTooltip();
            }
        }, true);

        document.addEventListener('pointerdown', () => this._hideTooltip(), true);
        document.addEventListener('scroll',      () => this._hideTooltip(), true);
    }
};
